module.exports = __webpack_public_path__ + "static/media/cpp.2c00067a.svg";